define('plugin/additional-fields/AdditionalFieldsPlugin',['require','lib/plugin/PluginAbstract','plugin/additional-fields/view/AdditionalFieldsView','plugin/additional-fields/collection/AdditionalFieldsCollection','Config'],function (require) {

	var PluginAbstract = require('lib/plugin/PluginAbstract');
    var AdditionalFieldsView = require('plugin/additional-fields/view/AdditionalFieldsView');
    var AdditionalFieldsCollection = require('plugin/additional-fields/collection/AdditionalFieldsCollection');
    var Config = require('Config');

	return PluginAbstract.extend({

        _detailsStepView: null,
		_additionalRegions: {
			fields: '#sb_additional_fields_container'
		},
        _fieldsCollection: new AdditionalFieldsCollection(),

		initStepManagerEvents: function () {
            this.listenTo(this._stepManager, 'step:render:details', this.beforeDetailsShow);
            this.listenTo(this._stepManager, 'step:show:datetime', this.onShowTimeline);
            this.listenTo(this._stepManager.getBookingModel(), 'change:service_id', this.loadFields);

            this.initClientEvents();
		},


        initClientEvents : function(){
            var _this = this;
            var messagesClientLoginChannel = Backbone.Wreqr.radio.channel('client_login');

            messagesClientLoginChannel.vent.on('client:signout', function () {
                _this._fieldsCollection.removeValues(); /// remove values from last client (with personal data)
            });
            messagesClientLoginChannel.vent.on('client:ready', function () { //is not reload page
                messagesClientLoginChannel.vent.on('client:signin', function () {
                    _this.loadFields(); /// load last fields values by current client
                });
            });
        },

        /**
         * Loads additional fields for service
         */
        loadFields: function () {
            var serviceId = this._stepManager.getBookingModel().get('service_id');
            if (serviceId) {
                this._fieldsCollection.fetch({
                    data: {
                        'service_id': serviceId
                    }
                });
            }
        },

        /**
         * Before details step shown add additional fields region
         *
         * @param DetailsStep step
         * @param DetailsView view
         * @param Marionette.Region region
         */
        beforeDetailsShow: function (step, view, region) {
            var bookingModel = this._stepManager.getBookingModel();

            if (Config.getInstance().getPluginStatus('waiting_list') && parseInt(bookingModel.get('wl')) ){
                return; //do not show intake forms if its book to waiting list
            }

            this._detailsStepView = view;
            _.each(this._additionalRegions, function (selector, region) {
                view.addRegion(region, selector);
            });

            this._detailsStepView.fields.show(new AdditionalFieldsView({
                bookingModel: bookingModel,
                collection: this._fieldsCollection
            }));
		},
        
        onShowTimeline: function () {
            this._fieldsCollection.each(function (fieldModel) {
                fieldModel.set({
                    'error': undefined
                });
            })
        },

        /**
         * Validates additional fields values
         *
         * @return Boolean
         */
        validate: function () {
            var res = true;

            var bookingModel = this._stepManager.getBookingModel();
            if (Config.getInstance().getPluginStatus('waiting_list') && parseInt(bookingModel.get('wl')) ){
                return true; //do not validate intake forms if its book to waiting list
            }

            this._fieldsCollection.each(function (model) {
                res = model.isValid() && res;
            });
            if (!res) {
                Backbone.Wreqr.radio.vent.trigger('field_error', 'shown', {
                    'type': 'additional_fields'
                });
            }

		    return this._stepManager.getBookingModel().isValid() && res;
        }
		
	});
	
});
